import { ActionPlanTargetPage } from '@features/action-plans/components/ActionPlanTargetPage';
import { findActionPlanForRoute, findActionPlanTargetById, getActionPlanSubjectSlug } from '@features/action-plans/helpers';
import { studentActionPlansQueryOptions } from '@features/action-plans/queries';
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId')({
    loader: async ({ context, params }) => {
        const actionPlans = await context.queryClient.ensureQueryData(studentActionPlansQueryOptions(params.studentNo));
        const actionPlan = findActionPlanForRoute(actionPlans, 'academic-support', params.subjectSlug);

        if (!actionPlan) {
            throw notFound();
        }

        const canonicalSubjectSlug = getActionPlanSubjectSlug(actionPlan);
        if (!canonicalSubjectSlug) {
            throw notFound();
        }

        if (params.subjectSlug !== canonicalSubjectSlug) {
            throw redirect({
                to: '/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId',
                params: {
                    studentNo: params.studentNo,
                    subjectSlug: canonicalSubjectSlug,
                    targetId: params.targetId,
                },
            });
        }

        const target = findActionPlanTargetById(actionPlan, params.targetId);
        if (!target) {
            throw notFound();
        }

        return { actionPlan, target };
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { actionPlan, target } = Route.useLoaderData();
    const { studentNo } = Route.useParams();

    return <ActionPlanTargetPage studentNo={studentNo} actionPlan={actionPlan} target={target} />;
}
